exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/backend/src/app/core/components/layout/sidebar/sidebar.component.scss
// module id = ../../../../../src/app/core/components/layout/sidebar/sidebar.component.scss
// module chunks = main